<template>
    <v-app>
      <v-layout row>
       <v-flex lg12 class="px-lg-0 px-2 mt-4">
                                 
                                    <v-menu ref="menu"  v-model="menu" :close-on-content-click="false" transition="scale-transition" :return-value.sync="dates" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="datess"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                             label="Please Select Date Range"
                                            :error-messages="errormsgDate ? 'Finish Date can\'t be earlier than Start Date' : ''"
                                            style="width:300px !important;"
                                            class="px-lg-0 px-5"
                                        ></v-text-field>
                                        </template>
                                       
                                        <v-date-picker
                                        v-model="dates"
                                        range
                                        no-title
                                         :min="getMinDate()"
                                        :max="lastMaxdate()"
                                        @change="getMinDate()"
                                        >
                                        <v-spacer></v-spacer>
                                       <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.menu.save([])"
                                        >
                                            Reset 
                                        </v-btn>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.menu.save(dates),changeDate()"
                                        >
                                            OK
                                        </v-btn>
                                        </v-date-picker>
                                        
                                    </v-menu>
                                    
                <span class="font-weight-medium text-lg-h6 px-lg-0 px-5"> Regular Class Feedback </span>
               <v-flex lg12 class="mt-n5 mt-lg-8 px-1"> <v-data-table :loading="loadingStatus" loading-text="Loading... Please wait" dense :headers="headers" :footer-props="{'items-per-page-options': [20,40,60,80,100]}" :items-per-page="20"  :items="tables" item-key="name" class="elevation-0">
                 
                                        

                                      <template v-slot:top>
                                        <v-text-field
                                          v-model="search"
                                          label="Search Tutor Name"
                                          class="mx-4 searchinput mt-lg-0 mt-5"
                                        ></v-text-field>
                                      </template>

                                      <template v-slot:item.no="{ index }">
                                      
                                       <span> {{ index + 1 }} </span>
                                      
                                    </template>

                                      <template v-slot:item.cm="{ item }">

                                            <v-btn v-model="item.cm" depressed small color="primary" @click="openDialog(item.s_id,item.todate)"> Listen </v-btn>


                                      </template>

                                      <template v-slot:item.as="{ item }">
                                      
                                       <span style="color:#53BD7E" > {{ item.as }} </span>
                                      
                                    </template>
                                     <template v-slot:item.suggestion="{ item }">

                                          {{gettranslateSuggestion(item.suggestion)}}
                                            
                                      </template>


                                  </v-data-table> 
              </v-flex>
           </v-flex>

               
       </v-layout>

        <v-dialog transition="dialog-bottom-transition" max-width="100%" v-model="dialogshow">
                    
                                        
                                        <v-card>
                                            <v-card-actions class="justify-end">
                                            <v-btn text @click="dialogshow=false">Close</v-btn>
                                            </v-card-actions>
                                            <v-card-text>
                                            
                                           
                                            <Ktt :call-date="call_date" :phone-no="phone_no" />
                                            
                                            </v-card-text>
                                            <v-card-actions class="justify-end">
                                            <v-btn text @click="dialogshow=false" >Close</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                        
      </v-dialog>
       

    </v-app>
</template>
<style scoped>
.searchinput{
  width:300px !important;
}
</style>
<script>
import Ktt from '@/components/MonitoringRating/KttIframe'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
Vue.use(axios)
export default {
    name: "LevelTest",
     components:{
      Ktt
    },
    data: () => ({
      rowsPerPageItems: [10, 20, 30, 40],
      pagination: {
          rowsPerPage: 20
        },
      tables: [],
        dates: [],
        menu: false,
        modal: false,
        menu2: false,
        ListGroup: null,
        errormsgDate: false,
        dialogshow:false,
        s_id:'',
        todate:'',
        StudentRecordData:'',
        call_date:'',
        phone_no:'',
        search:'',
        loadingStatus:false,
    }),
    mounted(){
      this.dataTable()
    },
    computed: {
      datess() {
        return this.dates.join(' - ')
      },
       headers(){ return  [{

          
          text: 'No.',
          align: 'center',
          sortable: false,
          value: 'no',
        },
        { text: 'Tutor',sortable: false,
           filter:value=>{
           return value != null &&
          this.search != null &&
          typeof value === 'string' &&
          value.toString().toLowerCase().indexOf(this.search.toLowerCase()) !== -1},
          align: 'center', value: 'tutor' },
        { text: 'Score',sortable: false,align: 'center', value: 'score' },
        { text: 'Suggestion',sortable: false, align: 'center',value: 'suggestion' },
        { text: 'Timestamp', value: 'ts', sortable:false, align: 'center', },
        { text: 'Evaluated by',sortable: false, value: 'eb' },
        { text: 'Class Date & Time',sortable: false,align: 'center', value: 'ct' },
        { text: 'Class MP3',sortable: false,align: 'center', value: 'cm' },
        
        ]}
    },
    methods:{
      getMinDate(){
        this.lastMaxdate()

        return  this.dates[0] ? this.dates[0]  : '' 
        },
      lastMaxdate(){
        //  var xs = new Date().toISOString().substr(0, 10)
        var y = new Date().toISOString().substr(0, 10)
        //  var y = parseInt(moment(xs).format('Y-M-D'),10)+1
          
          return y
          
        },
      async openDialog(val,date){
        await this.s_id
        await this.todate
        this.todate = date
        this.s_id=val
        await this.StudentRecordData
           axios.get('https://phone.megatalking.com/origin/api/regularclass_evaluation.php?s_id='+this.s_id+'&todate='+this.todate+'&action=classResult')
        // .then(response=>console.warn(response.data))
            .then((response)=> {this.StudentRecordData = response.data , 
                this.call_date= this.StudentRecordData.call_date,
                this.phone_no= this.StudentRecordData.phone
                return this.dialogshow=true
            })
        
      },
      changeDate(){
        this.tables= []
        if(this.dates[1]){

          if(this.dates[1] >= this.dates[0]){
            this.errormsgDate =false
            this.dataTable()
          }
          else {
            this.errormsgDate =true
          }

        } else {
          this.dataTable()
        }
        
      },
      get2Digit(num){
        return ( num.toString().length < 2 ? "0"+num : num ).toString()
      },
      gettranslateSuggestion(word){

            if(word === '조금 천천히 말해주세요.'){
              return 'Please speak a little slower.'
            } else if(word === '활기찬 분위기를 원해요.'){
              return 'I want a lively atmosphere.'
            } else if(word === '질문을 많이 해주세요.'){
              return 'Please ask me a lot of questions.'
            } else if(word === '틀린 부분을 바로바로 고쳐주세요.'){
              return 'Please correct my mistakes right away.'
            } else if(word === '많이 말하도록 유도해주세요.'){
              return 'Please encourage me to speak a lot.'
            } else { return word }

        
        
      },
      dataTable(){
        this.loadingStatus=true
      axios.get('https://phone.megatalking.com/origin/api/monitoring.php?action=getList')
        //.then(response=>console.warn(response.data))
        .then(response=>{
        
          this.ListGroup = response.data
         
          var start_date = this.dates != '' ? this.dates[0] : new Date().toISOString().substr(0, 10)
          var end_date = this.dates[1]
              for(let i = 0 ; i<=this.ListGroup.length ; i++){
                 
                 if(end_date){
                    
                   if((this.ListGroup[i].type=="RC" || this.ListGroup[i].type==="MC") && start_date <= moment(String(this.ListGroup[i].date)).format('Y-MM-DD')  && end_date >= moment(String(this.ListGroup[i].date)).format('Y-MM-DD')  && (this.ListGroup[i].tutor_name!='dave' && this.ListGroup[i].tutor_id!='nomal' && this.ListGroup[i].tutor_name!='TEST' && this.ListGroup[i].tutor_name!='jared')){
                        let timestamp = new Date(this.ListGroup[i].timestamp *1000)
                        let m = this.get2Digit(timestamp.getMonth('m')+1)
                        let d = this.get2Digit(timestamp.getDate())
                        let classDate = timestamp.getFullYear()+'-'+m+'-'+d
                        this.tables.push({
                  
                          tutor:this.ListGroup[i].tutor_full_name,
                          score:this.ListGroup[i].score/2,
                          suggestion:this.ListGroup[i].selected[0] && this.ListGroup[i].selected!=null ? this.ListGroup[i].selected[0].text ? this.ListGroup[i].selected[0].text +"\n "+this.ListGroup[i].text : this.ListGroup[i].text : '-',
                          eb:this.ListGroup[i].student_name,
                          ct: classDate+ '\n'+this.ListGroup[i].class_time,
                          ts:this.ListGroup[i].date,
                          cm:"mp3",
                          s_id:this.ListGroup[i].s_id,
                          todate:this.ListGroup[i].timestamp

                        })
                    
                      }



                } else {
                  
                    if((this.ListGroup[i].type=="RC" || this.ListGroup[i].type==="MC") && start_date == moment(String(this.ListGroup[i].date)).format('Y-MM-DD') && (this.ListGroup[i].tutor_name!="" && this.ListGroup[i].tutor_name!=null)  && (this.ListGroup[i].tutor_name!='dave' && this.ListGroup[i].tutor_name!='TEST' && this.ListGroup[i].tutor_name!='jared')){
                        let timestamp = new Date(this.ListGroup[i].timestamp *1000)
                        let m = this.get2Digit(timestamp.getMonth('m')+1)
                        let d = this.get2Digit(timestamp.getDate())
                        let classDate = timestamp.getFullYear()+'-'+m+'-'+d
                        this.tables.push({
                  
                          tutor:this.ListGroup[i].tutor_full_name,
                          score:this.ListGroup[i].score/2,
                          suggestion:this.ListGroup[i].selected[0] ? this.ListGroup[i].selected[0].text : '-',
                          eb:this.ListGroup[i].student_name,  
                          ct: classDate+ '\n'+this.ListGroup[i].class_time,
                          ts:this.ListGroup[i].date,
                          cm:"mp3",
                          s_id:this.ListGroup[i].s_id,
                          todate:this.ListGroup[i].timestamp

                        })
                    
                      }
                 }
                  
                 this.loadingStatus=false

              }
        
        })

        
        
      }
    },
}
</script>